import { Nullable } from '@core/helpers/nullable';
import { RequestDTO } from './Request';
import { DeviceSettingsProfile } from './DeviceSettingsProfile';
import { DeviceDataProcessed } from './DeviceDataProcessed';

export type RequestDeviceModelResponse = {
  modelId: number | null;
  isTelemetry: boolean | null;
};

/**
 * Сущность добавленного Устройства к Заявке.
 * Можно сказать сущность связи между Устройством и Заявкой.
 * Связана с самим Устройством по полю "deviceHash".
 */
export type RequestDevice = {
  createdAt: Date;
  createdId: number;
  deviceHash: string;
  deviceModelId: RequestDeviceModelId;
  hasProtectCase: Nullable<boolean>;
  id: number;
  installDate: Date;
  key: Nullable<string>;
  kit: Nullable<string>;
  name: string; // SIM1
  profile: Nullable<Pick<DeviceSettingsProfile, 'id' | 'name'>>;
  protectCaseNumber: Nullable<number>;
  request: RequestDTO['id'];
  secondSim: Nullable<string>;
  status: Nullable<DeviceDataProcessed>;
  updatedAt: Date;
  // Бортовое напряжение, если deviceModelId = ONLINE SLIM
  onboardVoltage: Nullable<RequestDeviceOnboardVoltage>;
  // Способ крепления устройства, если deviceModelId != ONLINE SLIM
  mountType: Nullable<RequestDeviceMountType>;
  // Наличие выключателя массы (для устройств с id = [12, 16, 17])
  cutoffSwitch: Nullable<boolean>;
};

export type RequestDeviceWithoutAdditionalSettings = Pick<
  RequestDevice,
  'name' | 'installDate' | 'secondSim' | 'hasProtectCase' | 'protectCaseNumber'
>;

export type RequestDeviceWithAdditionalSettings = Pick<
  RequestDevice,
  | 'name'
  | 'installDate'
  | 'secondSim'
  | 'hasProtectCase'
  | 'protectCaseNumber'
  | 'onboardVoltage'
  | 'mountType'
  | 'cutoffSwitch'
>;

export enum RequestDeviceOnboardVoltage {
  TWELVE_VOLT = '12v',
  TWENTY_FOUR_VOLT = '24v',
}

export enum RequestDeviceMountType {
  MAGNETS = 'Магниты',
  DOUBLE_SIDED_TAPE = 'Двусторонний скотч',
  TIE = 'Стяжка',
  METAL_MOUNT = 'Металлический крепеж',
}

export const RequestDeviceCutoffSwitch = {
  Есть: true,
  Нет: false,
};

export enum RequestDeviceModelId {
  INVIS_DUOS = 4,
  INVIS_DUOS_S = 7,
  INVIS_DUOS_3D_L = 9,
  INVIS_DUOS_ONLINE_LITE = 12,
  INVIS_DUOS_CONTAINER = 14,
}

export enum RequestDeviceModelName {
  INVIS_DUOS = 'INVIS DUOS',
  INVIS_DUOS_S = 'INVIS DUOS S',
  INVIS_DUOS_3D_L = 'INVIS DUOS 3D L',
  INVIS_DUOS_ONLINE_LITE = 'INVIS DUOS ONLINE LITE',
  INVIS_DUOS_CONTAINER = 'INVIS DUOS CONTAINER',
}
